export default __webpack_public_path__ + "static/media/6.dc8ed4b3.png";